import { render, staticRenderFns } from "./SlotReports.vue?vue&type=template&id=84454e40&scoped=true&"
import script from "./SlotReports.vue?vue&type=script&lang=js&"
export * from "./SlotReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84454e40",
  null
  
)

export default component.exports